import React from 'react';
function LogOut({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 21H6a2 2 0 01-2-2V5a2 2 0 012-2h4M15 17l5-5-5-5M20 12H8"
      />
    </svg>
  );
}

export default LogOut;
